import apiClient from '@u/apiClient'
import GetBankAccountListController from '@/wayfinder/actions/App/Http/Controllers/BankAccount/GetBankAccountListController'
import GetBankAccountByIdController from '@/wayfinder/actions/App/Http/Controllers/BankAccount/GetBankAccountByIdController'
import GetBankAccountActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/BankAccount/GetBankAccountActivitiesByIdController'
import CreateBankAccountController from '@/wayfinder/actions/App/Http/Controllers/BankAccount/CreateBankAccountController'
import UpdateBankAccountController from '@/wayfinder/actions/App/Http/Controllers/BankAccount/UpdateBankAccountController'
import DeleteBankAccountController from '@/wayfinder/actions/App/Http/Controllers/BankAccount/DeleteBankAccountController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
// import router from '@/router'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region fetch
  async fetchBankAccountList({ commit }) {
    await apiClient
      .route(GetBankAccountListController.get())
      .then(async (response) => {
        await commit('setBankAccountList', response.data.bank_accounts)
        await commit('setBankAccountMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchBankAccountList', reason)
      })
  },
  async fetchBankAccountById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetBankAccountByIdController.get({ bank_account: payload.id }))
      .then(async (response) => {
        await commit('setBankAccount', response.data.bank_account)
        await commit('setBankAccountMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchBankAccountById', reason)
      })
  },
  async fetchNewBankAccount({ commit }) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(GetNewModelController.get({ query: { model: 'BankAccount' } }))
      .then(async (response) => {
        await commit('setBankAccount', response.data.BankAccount)
        await commit('setBankAccountMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchNewBankAccount', reason)
      })
  },
  fetchBankAccountActivityByBankAccountID({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetBankAccountActivitiesByIdController.get({
            bank_account: payload.bank_account_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region store
  async storeBankAccount({ commit }, payload) {
    await apiClient
      .route(CreateBankAccountController.post(), payload.bank_account)
      .then(async (response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
          await commit('setBankAccountList', response.data.bank_accounts)
          await commit('setBankAccountMetadata', response.data.metadata)
        }
      })
      .catch(async (reason) => {
        console.error('storeBankAccount', reason)
      })
  },
  // endregion

  // region update
  async updateBankAccount({ commit }, payload) {
    await apiClient
      .route(
        UpdateBankAccountController.put({ bank_account: payload.id }),
        payload.bank_account
      )
      .then(async (response) => {
        if (response.status === 201) {
          processSuccessCallback(payload)
          let bank = null
          if (payload.single_bank_account) {
            bank = response.data.bank_accounts.find(
              (bank) => bank.id === payload.id
            )
            await commit('setBankAccountList', bank)
            await commit('setBankAccountMetadata', response.data.metadata)
          } else {
            await commit('setBankAccountList', response.data.bank_accounts)
          }
        }
      })
      .catch(async (reason) => {
        console.error('updateBankAccount', reason)
      })
  },
  // endregion

  // region delete
  async deleteBankAccountById({ commit }, payload) {
    await apiClient
      .route(
        DeleteBankAccountController.delete.delete({ bank_account: payload.id })
      )
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setBankAccountList', response.data.bank_accounts)
          await commit('setBankAccountMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('deleteBankAccountById', reason)
      })
  },
  // endregion

  // region undoDelete
  async undoDeleteBankAccountById({ commit }, payload) {
    await apiClient
      .route(DeleteBankAccountController.undo.get({ id: payload.id }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setBankAccountList', response.data.bank_accounts)
          await commit('setBankAccountMetadata', response.data.metadata)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        console.error('undoDeleteBankAccountById', reason)
      })
  }
  // endregion
}
